import type { PillTone } from "@/components/ui/pill";
import type { DevicePresence } from "@/types/device-manager.types";

// Presença do CLP derivada de `lastSeenAt` (não há campo persistido;
// ver research.md R5). Janela de frescor alinhada à cadência de telemetria/heartbeat.
const PRESENCE_STALE_MS = 90_000;

// `nowMs` tem default `Date.now()` no corpo do helper (não no render do componente) —
// mesmo padrão de `SensorHealthChip`/`LineDetailHeader` (react-hooks/purity).
export function devicePresence(lastSeenAt: string | null, nowMs = Date.now()): DevicePresence {
  if (!lastSeenAt) return "unknown";
  const t = Date.parse(lastSeenAt);
  if (Number.isNaN(t)) return "unknown";
  return nowMs - t <= PRESENCE_STALE_MS ? "online" : "offline";
}

export const PRESENCE_LABEL: Record<DevicePresence, string> = {
  online: "Online",
  offline: "Offline",
  unknown: "Sem registro",
};

export const PRESENCE_TONE: Record<DevicePresence, PillTone> = {
  online: "success",
  offline: "danger",
  unknown: "neutral",
};
